import { Popover } from "antd";
import { DownloadAppPopover } from "./DownloadAppPopover";
import React, { useMemo, useRef } from "react";
import css from "./index.module.less";
import { getString } from "../index";

export interface DownloadAppProps {
  showQRCode?: boolean;
  style?: React.CSSProperties;
  titleColor?: string;
}

const DownloadApp = (props: DownloadAppProps) => {
  const { showQRCode, style, titleColor } = props;
  const rootRef = useRef(null);

  const downLoadMethodsData = useMemo(() => {
    return [
      {
        ico: require("../images/ico_apple.png"),
        methodName: getString("homepage_downloadapp_ios"),
      },
      {
        ico: require("../images/ico_android.png"),
        methodName: getString("homepage_downloadapp_android"),
      },
    ];
  }, []);

  const downLoadMethods = useMemo(() => {
    return downLoadMethodsData.map((dwMethodItem, index) => {
      const { ico, methodName } = dwMethodItem;
      const downloadView = (
        <div key={methodName} className={css.dw_method_item}>
          <div className={css.dw_method_item_left}>
            <i
              className={css.dw_method_item_ico}
              style={{ backgroundImage: `url("${ico}")` }}
            />
            <span className={css.dw_method_name}>{methodName}</span>
          </div>
          <div className={css.dw_method_item_right}>
            <i className={css.dw_method_item_downico} />
          </div>
        </div>
      );

      if (index === 0) {
        return (
          <Popover
            key={methodName}
            placement="rightTop"
            content={<DownloadAppPopover isAndroid={false} />}
            trigger={"hover"}
            getPopupContainer={() => rootRef.current!}
          >
            {downloadView}
          </Popover>
        );
      } else {
        return (
          <Popover
            key={methodName}
            placement="rightTop"
            content={<DownloadAppPopover isAndroid={true} />}
            trigger={"hover"}
            getPopupContainer={() => rootRef.current!}
          >
            {downloadView}
          </Popover>
        );
      }
    });
  }, [downLoadMethodsData, showQRCode]);

  return (
    <div className={css.download_app} style={style} ref={rootRef}>
      <div className={css.download_app_left}>
        <h3>
          <div
            className={`${css.download_app_title} ${css.download_app_title_home}`}
            style={{ color: titleColor }}
          >
            {getString("homepage_downloadapp_title")}
          </div>
        </h3>
        <div className={css.dw_method_list}>
          <div>{downLoadMethods}</div>
          {showQRCode && (
            <div className={css.download_qrcode_wrap}>
              <img
                className={css.download_qrcode}
                src={require("../images/dow_codeImg.png")}
                alt=""
              />
            </div>
          )}
        </div>
      </div>
      <div className={css.download_app_right}>
        <img
          className={css.img}
          src={require("../images/app&web_pic_cut.png")}
          alt=""
        />
      </div>
    </div>
  );
};

export default DownloadApp;
